export const epkLinks = [
  {
    id: 'bio',
    link: '/files/allochiria_bio.pdf',
    // link: 'https://www.dropbox.com/scl/fi/y5l6sfjo2ausi0hc1icjm/Allochiria-bio-EN-2025.pdf?rlkey=gduxu8gjzypioikz8d3g2zfd2&dl=0',
    label: 'Biography (pdf)',
  },
  {
    id: 'tour-rider',
    link: '/files/allochiria_tour_hospitality_rider_2025.pdf',
    label: 'Tour & Hospitality rider 2025 (pdf)',
  },
  {
    id: 'tech-rider-tour',
    link: '/files/allochiria_tech_rider_2025.pdf',
    // link: 'https://www.dropbox.com/scl/fi/go7pmxl2l4l5wcfdroezo/ALLOCHIRIA-2025-TECH-RIDER.pdf?rlkey=1jitkskikq3275739nndrqlm3&dl=0',
    label: 'Technical rider (pdf)',
  },
  {
    id: 'tech-rider-tour-with-sound-engineer',
    link: '/files/allochiria_tech_rider_2025_sound_engineer.pdf',
    label: 'ATHENS tech rider (pdf)',
  },
  {
    id: 'may-2025-tour',
    link: 'https://www.dropbox.com/scl/fo/mth8igegyvt1grfuhal60/AJwX1Jq1QG-_W3KcGTsd0pQ?rlkey=q5on47d1x7qy9s1ydz0bdz76g&dl=0',
    label: 'May tour 2025 posters & templates (Dropbox)',
  },
  {
    id: 'reels-tour',
    link: 'https://www.dropbox.com/scl/fo/na1mhyzob4pblimu4h6w7/AM8DJApZc8-_-JJ2doXddXY?rlkey=7ixuz5n9s8ikkfitnecewr7ij&dl=0',
    label: 'Reels for social media',
  },
  {
    id: 'photos',
    link: 'https://www.dropbox.com/scl/fi/wruyrtp8rs0g6ahgng2w3/allochiria-photos-2023.zip?rlkey=fkhr5cytmnyxqbbm3fktf3ov8&dl=0',
    label: 'Band photos (Dropbox)',
  },
  {
    id: 'logos',
    link: 'https://www.dropbox.com/sh/uv4ult9x0hstoyv/AADzHBc__kobC8e7WG2nZqrva?dl=0',
    label: 'Logo pack (Dropbox)',
  },
];
